export default __webpack_public_path__ + "images/SI.ffe1308.png";